import { FC, useMemo } from "react";

import { useSimpleNavigation } from "@ryde/redux";
import {
  IInjectedDrawerProps,
  serializedOpenedDrawersDependency,
  useDrawers,
} from "@ryde/shared";

import { drawersRegister } from "./drawers-register";

export const DrawersContainer: FC = () => {
  const { drawers, closeDrawer } = useDrawers();
  const { isAddOrEditRoute } = useSimpleNavigation();

  const editRouteDrawerNumberCorrection = isAddOrEditRoute ? 1 : 0;

  const openedDrawersSerializedValue = useMemo(() => {
    return serializedOpenedDrawersDependency(drawers);
  }, [drawers]);

  const drawersListMemoized = useMemo(() => {
    return drawers;
    // to avoid re-render of the drawers list serialized value is used
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openedDrawersSerializedValue]);

  return drawersListMemoized.map(
    (
      { drawerProps: { type, onCloseCustomAction, ...restDrawerProps } },
      index,
    ) => {
      const onCloseDrawer = (): void => {
        closeDrawer(type);
        onCloseCustomAction?.();
      };

      const DrawerContent = drawersRegister[type] as FC<IInjectedDrawerProps>;

      if (!DrawerContent) {
        return null;
      }

      return (
        <DrawerContent
          key={`${type}_${index}_${Object.keys(restDrawerProps ?? {}).join()}`}
          onCloseDrawer={onCloseDrawer}
          {...restDrawerProps}
          drawerNumber={index + editRouteDrawerNumberCorrection}
        />
      );
    },
  );
};
